import { render } from "./FileListCard.vue?vue&type=template&id=2273a82b"
import script from "./FileListCard.vue?vue&type=script&lang=js"
export * from "./FileListCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/www/omniauto/omninext/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__